
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { SidebarHeader } from '@/components/ui/sidebar';

export function AdminSidebarHeader() {
  const navigate = useNavigate();

  const handleLogoClick = () => {
    navigate('/');
  };

  return (
    <SidebarHeader className="border-b border-white/20">
      <div 
        className="flex items-center gap-2 px-4 h-16 cursor-pointer hover:bg-gray-50 transition-colors"
        onClick={handleLogoClick}
      >
        <div className="flex items-center gap-2">
          <img
            src="/lovable-uploads/ba1e90a0-0271-4ea2-80f0-40d8acccb492.png"
            alt="Resonow Logo"
            className="h-8 w-8"
          />
          <span className="text-xl font-semibold text-amber-700">Resonow</span>
        </div>
      </div>
    </SidebarHeader>
  );
}
